export default __webpack_public_path__ + "static/media/Bottom-Image.2d5323a2.png";